import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TEmployeeListState } from './employee-list.models';

export const getEmployeeListState = (state: TPlani8State) => state.employeeListInfo;

export const getEmployeeListInfo = createSelector(
  getEmployeeListState,
  (state: TEmployeeListState) => state.employeeListingInfo,
);

export const getTeamListInfo = createSelector(
  getEmployeeListState,
  (state: TEmployeeListState) => state.teamListingInfo,
);

export const getUserPaginationOption = createSelector(
  getEmployeeListState,
  (state: TEmployeeListState) => state.userPaginationOption,
);
